import React, { useEffect, useState } from 'react';
import analytics from '../lib/analytics';
import { supabase } from '../lib/supabaseClient';
import { Button as FcButton } from '../ui';

export default function ConsentBanner() {
  const [visible, setVisible] = useState(false);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    try {
      const consent = analytics.hasConsent();
      if (!consent) setVisible(true);
    } catch (e) {
      // ignore
    }
  }, []);

  if (!visible) return null;

  const accept = async () => {
    try {
      setSaving(true);
      const measurementId = import.meta.env.VITE_GA_ID || import.meta.env.VITE_GA4_MEASUREMENT_ID;
      analytics.grantConsent(measurementId);
      // Persist to server for logged-in users
      try {
        const { data: userData } = await supabase.auth.getUser();
        const user = userData?.user;
        if (user && user.id) {
          await supabase
            .from('profiles')
            .update({ analytics_consent: true, analytics_consent_at: new Date().toISOString() })
            .eq('id', user.id);
        }
      } catch (e) {
        // fail silently
      }
    } finally {
      setSaving(false);
      setVisible(false);
    }
  };

  const decline = async () => {
    try {
      setSaving(true);
      analytics.revokeConsent();
      try {
        const { data: userData } = await supabase.auth.getUser();
        const user = userData?.user;
        if (user && user.id) {
          await supabase
            .from('profiles')
            .update({ analytics_consent: false, analytics_consent_at: new Date().toISOString() })
            .eq('id', user.id);
        }
      } catch (e) {
      }
    } finally {
      setSaving(false);
      setVisible(false);
    }
  };

  return (
    <div className="fixed bottom-4 left-4 right-4 md:left-auto md:right-6 z-50 bg-surface-card border rounded-lg p-3 shadow-sm flex items-center justify-between gap-3">
      <div className="text-sm text-content-primary">
        Allow analytics cookies to help improve Footy Coach? You can change this anytime in Settings.
      </div>
      <div className="flex gap-2">
        <FcButton variant="tertiary" type="submit" onClick={decline} disabled={saving} className="">Decline</FcButton>
        <FcButton variant="primary" type="submit"  onClick={accept} disabled={saving} className="">{saving ? 'Saving...' : 'Accept'}</FcButton>
      </div>
    </div>
  );
}
